import { AppointmentContainerBase } from "@/components/layout/AppointmentContainer";
import styled from "@emotion/styled";
import { LightMode } from "@repo/skapa";
import { Variables } from "@repo/skapa";

export const CalendarColumn = styled.div<{ width: number }>`
  width: ${({ width }) => `${width}px`};

  position: relative;
`;

export const WeekBlock = styled.div<{
  width: number;
  height: number;
  alignItems?: string;
  color?: string;
  noBorderRight?: boolean;
  noBorderBottom?: boolean;
}>`
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};
  background-color: ${({ color }) =>
    color ? color : LightMode.colourStaticWhite};

  display: flex;
  justify-content: center;

  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};

  ${({ noBorderRight }) =>
    noBorderRight
      ? "border-right: none"
      : `border-right: 1px solid ${LightMode.colourNeutral4}`};
  ${({ noBorderBottom }) =>
    noBorderBottom
      ? "border-bottom: none"
      : `border-bottom: 1px solid ${LightMode.colourNeutral4}`};
`;

export const ClickableWeekBlock = styled(WeekBlock)`
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};

  width: ${({ width }) => `${width}px`};

  background-color: ${({ color }) =>
    color ? color : LightMode.colourStaticWhite};

  &:hover {
    cursor: pointer;
    border: ${Variables.thicknessThin} dashed
      ${LightMode.colourInteractiveEmphasisedBgDefault};
    background: #f3f7fa;
    margin-top: -1px;
    margin-left: -1px;
    width: ${({ width }) => `${width + 1}px`};
    height: ${({ height }) => `${height + 1}px`};
  }

  display: flex;
  justify-content: center;

  height: ${({ height }) => `${height}px`};
`;

export const MediumContainer = styled.div`
  display: none;

  @media (min-width: ${Variables.breakpointL}) {
    display: block;
  }
`;

export const AppointmentBlock = styled(AppointmentContainerBase)`
  padding: 0 2px;

  ${({ dashed, borderColor }) =>
    dashed ? "padding-left: 5px;" : `border-left: 3px solid ${borderColor};`}

  ${({ dashed }) =>
    !dashed
      ? `
        &::after {
          left: -3px;
        }
      `
      : ""}

  cursor: pointer;
  overflow: hidden;
`;
